import React from 'react';

const SuccessSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.2341 7.39844L10.8714 16.6016L5.53711 10.7588" stroke="white" stroke-opacity="0.6" stroke-width="1.3"/>
  </svg>
);

export default SuccessSvg;